import { ShowHide } from './showHideController';
import { initialiseInstanceComponents } from '../../shared/instanceComponentInitialiser';
import { AttributeEnums } from '../../shared/utilities/enums/attributeEnums';
import { HelperUtils } from '../../shared/utilities/helperUtils';

export function initialiseShowHide() {
    initialiseInstanceComponents<ShowHide>(ShowHide, HelperUtils.addDataAttributeTags(AttributeEnums.ShowHide.ShowHideToggle), showHideFactory);
}

function showHideFactory(currentElement: Element): void {
    let showHideToggleId = currentElement.getAttribute(AttributeEnums.ShowHide.ShowHideToggle);
    let showHideContentElements = document.querySelectorAll(HelperUtils.addDataAttributeTags(AttributeEnums.ShowHide.ShowHideContent, showHideToggleId));
    let newShowHide = new ShowHide(currentElement, showHideContentElements);
    (<any>window)['sh' + currentElement.getAttribute(AttributeEnums.ShowHide.ShowHideToggle) + 'ShowHide'] = newShowHide;
}